import { render, staticRenderFns } from "./VerSalida.vue?vue&type=template&id=64b05404&scoped=true"
import script from "./VerSalida.vue?vue&type=script&lang=js"
export * from "./VerSalida.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VerSalida.vue?vue&type=style&index=1&id=64b05404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b05404",
  null
  
)

export default component.exports